import moment from 'moment';

const DRFTags = (doc, data, clinica, typeDocumentInvoice) => {
    var DRF = doc.createElement("DRF");

    //Codigo de Autorización a Facturación Electronica
    var DRF_1 = doc.createElement("DRF_1");
    DRF_1.innerHTML = data.detallesFacturacion.resolucion_fe;//codigo de autorización
    DRF.appendChild(DRF_1);

    //Fecha de Inicio a Facturación Electronica
    var DRF_2 = doc.createElement("DRF_2");
    DRF_2.innerHTML = typeDocumentInvoice == "INVOICE" ? moment(data.detallesFacturacion.fecha_inicio).format("YYYY-MM-DD") : moment(data.detallesReferenciaFactura.fecha_inicio_nota_credito).format("YYYY-MM-DD");
    DRF.appendChild(DRF_2);

    //Fecha Final a Facturación Electronica
    var DRF_3 = doc.createElement("DRF_3");
    DRF_3.innerHTML = typeDocumentInvoice == "INVOICE" ? moment(data.detallesFacturacion.fecha_final).format("YYYY-MM-DD") : moment(data.detallesReferenciaFactura.fecha_final_nota_credito).format("YYYY-MM-DD");
    DRF.appendChild(DRF_3);

    //Prefijo de Facturación
    var DRF_4 = doc.createElement("DRF_4");
    DRF_4.innerHTML = typeDocumentInvoice == "INVOICE" ? data.detallesFacturacion.prefijo : data.detallesReferenciaFactura.prefijo;
    DRF.appendChild(DRF_4);

    //Rango de Numeración Inicial
    var DRF_5 = doc.createElement("DRF_5");
    DRF_5.innerHTML = typeDocumentInvoice == "INVOICE" ? data.detallesFacturacion.inicio : data.detallesReferenciaFactura.inicio_nota_credito;
    DRF.appendChild(DRF_5);

    //Rango de Numeración Final
    var DRF_6 = doc.createElement("DRF_6");
    DRF_6.innerHTML = typeDocumentInvoice == "INVOICE" ? data.detallesFacturacion.limite : data.detallesReferenciaFactura.limite_nota_credito;
    DRF.appendChild(DRF_6);

    return DRF
}

export default DRFTags;